import { userNavOverridesAtom } from '@/atoms/queries/user';
import { usePlayerNavItems } from '@/components/navigation/subNav/PlayerNav';
import env from '@/env';
import { MenuItemText } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { patchUserNavOverridesAtom } from '@/atoms/mutations/user/user';
import { navigationPlayerIdAtom } from '@/atoms/navigation';
import { usePlayerNavigationItems } from './subNavigation/usePlayerNavigationItems';

export const PLAYER_BASE_ROUTE = `https://${env.VITE_IQ_DOMAIN}/player`;

export const usePlayerNavigationItem = (crossPlatform = false) => {
  const {
    t,
    i18n: { language: locale },
  } = useTranslation('navigation');

  const navigate = useNavigate();
  const { datahubId, iqId } = useAtomValue(navigationPlayerIdAtom);
  const { mutateAsync: patchUserNavOverrides } = useAtomValue(patchUserNavOverridesAtom);
  const userNavOverrides = useAtomValue(userNavOverridesAtom);
  const playerPath = `/${locale}/player/${datahubId}/`;

  const theme = useTheme();
  const isTouch = theme.mqMatch('md');

  const newXpPlayerSubnav = usePlayerNavItems(playerPath);
  const oldXpPlayerSubnav = usePlayerNavigationItems();

  const newXpDefaultPath = `${playerPath}dashboard`;
  const oldXpDefaultPath = `${PLAYER_BASE_ROUTE}/${iqId}`;

  const isClassicPlayerXp = userNavOverrides.player;
  const defaultPlayerPath = isClassicPlayerXp ? oldXpDefaultPath : newXpDefaultPath;
  const otherExperiencePath = isClassicPlayerXp ? newXpDefaultPath : oldXpDefaultPath;
  const playerSubnav = isClassicPlayerXp ? oldXpPlayerSubnav : newXpPlayerSubnav;
  const translationKey = isClassicPlayerXp ? 'newExperience' : 'classicExperience';

  const togglePlayerSectionXp = async () => {
    await patchUserNavOverrides({
      ...userNavOverrides,
      player: !isClassicPlayerXp,
    });

    // handling the navigation here so we can await the patch request before redirecting
    if (otherExperiencePath.startsWith('https')) {
      window.location.href = otherExperiencePath;
    } else {
      navigate(otherExperiencePath);
    }
  };

  return {
    id: 'player',
    icon: 'PlayerSoccer' as const,
    path: defaultPlayerPath,
    label: t('primary.player'),
    subNav: [
      ...playerSubnav,
      ...(crossPlatform
        ? [
            {
              id: 'player-switch-experience',
              label: (
                <div>
                  <hr className="w-full absolute left-0 top-0 border-layering-1-strong" />
                  <MenuItemText isTouch={isTouch}>
                    <b>{t(`crossPlatform.secondary.${translationKey}`)}</b>
                  </MenuItemText>
                </div>
              ),
              onClick: togglePlayerSectionXp,
            },
          ]
        : []),
    ],
  };
};
